import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SharedStatesModule } from 'shared-states';
import { CommonModule } from "@angular/common";
import { FooterComponent } from "./components/footer/footer.component";
import { TranslateModule } from "@ngx-translate/core";
import { CookieStorageService } from "./services/cookie-storage.service";
import { TscBetaDirective } from "./directives/tsc-beta.directive";
import { CookieSettingsOverviewComponent } from './components/cookie-settings-overview/cookie-settings-overview.component';
import { TscDialogComponent } from './components/tsc-dialog/tsc-dialog.component';
import { MatDialogModule } from "@angular/material/dialog";
import { WebComponentsModule } from "teccom-web-components";
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { RedirectionServiceService } from "./services/redirection-service.service";
import {SvgAssetBundlerModule} from "./svg-asset-bundler/svg-asset-bundler.module";
import SvgAssetDictionary from "./svg-asset-source/svg-asset-dictionary";

// Material modules (previously provided by SharedComponentsModule)
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [
    FooterComponent,
    CookieSettingsOverviewComponent,
    TscBetaDirective,
    TscDialogComponent,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedStatesModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    MatDividerModule,
    MatExpansionModule,
    MatTabsModule,
    MatBadgeModule,
    WebComponentsModule,
    SvgAssetBundlerModule.forYouAndMe({svgAssets: SvgAssetDictionary})
  ],
  exports: [
    CommonModule,
    FormsModule,
    SharedStatesModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    MatDividerModule,
    MatExpansionModule,
    MatTabsModule,
    MatBadgeModule,
    FooterComponent,
    TscBetaDirective,
    TscDialogComponent,
    ConfirmDialogComponent,
    WebComponentsModule,
    SvgAssetBundlerModule
  ],
  providers: [
    CookieStorageService,
    RedirectionServiceService
  ]
})
export class ShellSharedModule {
  static forChild(): ModuleWithProviders<ShellSharedModule> {
    return {
      ngModule: ShellSharedModule
    };
  }
}
